import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';

export const giftCertificateProductSelector = selector<Record<string, number>>({
    key: 'giftCertificateProductSelector',
    get: async ({ get }) => {
        try {
            const productList = await OnlineSalesUnauthenticated.getOnsaCampaigns(true);
            const productMap: Record<string, number> = {};
            for (const product of productList) {
                productMap[product.productCode] = product.value;
            }
            return productMap;
        } catch (e) {
            console.error(e);
            return {};
        }
    }
});
